import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import axiosInstance, { getAPIURL } from '../axiosInstance';

export const useDeletePost = (
  options?: UseMutationOptions<unknown, Error, number, unknown>,
) => {
  return useMutation<unknown, Error, number>({
    ...options,
    mutationFn: async (id: number) => {
      return axiosInstance
      .delete(getAPIURL(`/Post/Delete?id=${id}`))
      .then((res) => res.data);
    },
  });
};